import { useGetPermissionsQuery } from '../features/RoleManagement/services/roleApi';

export function useAvailablePermissions() {
	const { data, ...result } = useGetPermissionsQuery();

	return { data: data?.content, ...result };
}
